import React from "react";
export default function RightArrow(props) {
    const { height = 20, color } = props;
    return (React.createElement("svg", { height: height, id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 122.88 111.27" },
        React.createElement("title", null, "Strza\u0142ka w prawo"),
        React.createElement("path", { fill: color === "secondary" ? "var(--cl-main-dark)"
                : color === "secondary-background" ?
                    "var(--color-third)"
                    : "var(--c-muted)", d: "M0,31.47H58.44V9.32c.16-3.71,1.39-6.35,3.7-7.88C68.33-2.69,74.45,3,78.76,6.87,90.94,17.92,113,43.05,119.44,48.53c4.59,4.15,4.59,10.06,0,14.21-6.61,5.66-30,32.16-41.85,42.71-4.12,3.66-9.74,8.18-15.45,4.37-2.31-1.52-3.54-4.16-3.7-7.87V79.79H0V31.47Z" })));
}
